export default function AlertHttpResponseInterceptor($q, AlertService, Utils, IgnoreServerErrors) {
  'ngInject';

  return {
    request(config) {
      if (IgnoreServerErrors.isIgnoring()) {
        return Object.assign({}, config, { maybeIgnoreErrors: true });
      }

      return config;
    },
    responseError(rejection) {
      const config = rejection.config;

      if (config?.ignoreGlobalErrorHandler && rejection.status !== 502) {
        return $q.reject(rejection);
      }

      if (
        rejection.config &&
        config.maybeIgnoreErrors &&
        IgnoreServerErrors.shouldIgnore(rejection)
      ) {
        console.warn('EATEN', rejection);
        return $q.reject(rejection);
      }

      if (rejection.status !== 401 && rejection.data) {
        const message = Utils.getErrorMessages(rejection);

        // toString called on an object returned by $sce.trustAsHtml is the unwrapped value
        if (message?.toString().length) {
          AlertService.add(message, rejection.status);
        }
      }

      return $q.reject(rejection);
    },
  };
}
